import maintenanceImg from "@assets/images/maintence.jpg";
import { Button } from "@design-system/ui/button";
import { trans } from "@mongez/localization";

interface MaintenanceContentProps {
  type?: "general" | "settings";
  onRetry?: () => void;
}

export function MaintenanceContent({
  type = "general",
  onRetry,
}: MaintenanceContentProps) {
  const isSettingsMaintenance = type === "settings";

  const title = isSettingsMaintenance
    ? trans("error.settingsUnavailable")
    : trans("error.underMaintenance");

  const message = isSettingsMaintenance
    ? trans("error.settingsUnavailableMessage")
    : trans("error.underMaintenanceMessage");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="flex flex-col items-center gap-5 text-center">
        <img
          src={maintenanceImg}
          alt="maintenance"
          className="w-[400px] md:w-[500px]"
        />
        <h1 className="text-xs sm:text-base">
          {trans("error.weAreComingSoon")}
        </h1>
        <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 sm:text-2xl">
          {title}
        </h2>
        <p className="mx-auto max-w-md text-xs text-gray-600 dark:text-gray-300 sm:text-sm">
          {message}
        </p>

        {onRetry && (
          <Button onClick={onRetry} className="mt-4">
            {trans("tryAgain")}
          </Button>
        )}
      </div>
    </div>
  );
}
